import { FormBuilder } from '@/features/quote-and-apply-builder';

export function FormBuilderPage() {
  return <FormBuilder />;
}

export default FormBuilderPage;
